export const HealthcareServiceProviderCode = "OrganizationType.HealthcareServiceProvider";
export const HealthcareServiceSupplierCode = "OrganizationType.HealthcareServiceSupplier";
export const DisplayNameTag = "OrganizationNameTag.Display";

export interface OrganizationDetail {
    id: number;
    globalIdentifier: number;
    officialName: string;
    tradeName?: string;
    statutoryName?: string;
    companyNumber?: string;
    alias?: string;
    shortName10?: string;
    shortName5?: string;
    isActive: boolean;
    typeCode: string;
    countryCode: string;
    ukHspAdditionalInfo?: UkInfo;
    deHspAdditionalInfo?: DeInfo;
    healthcareServiceSupplierInfo?: HealthcareServiceSupplierInfo;
    regulationCode?: string;
    regulationCodeType?: string;
    providerCategoryCode?: string;
    mrdmLegacyIdentifier?: MrdmLegacyIdentifier;
    logexLegacyIdentifier: LogexLegacyIdentifier;
    coinsLegacyIdentifier: CoinsLegacyIdentifier;
    addresses: Address[];
    contacts: Contact[];
    tradeNameTags: string[];
    statutoryNameTags: string[];
    officialNameTags: string[];
    isDemo: boolean;
    isTest: boolean;
}

export interface OrgNameAndIdentifier {
    name: string;
    globalIdentifier: number;
}

export interface OrgValidationDisplayInfo {
    name: string;
    identifier: number;
    percentage: string;
}

export class UkInfo {
    nationalGroupingCode: string;
    highLevelGeographyCode: string;
}

export class DeInfo {
    numberOfBedsId: number;
}

export class HealthcareServiceSupplierInfo {
    healthcareServiceSupplierCategoryCode: string;
    serviceAndGoods: NameId[];
}

export class MrdmLegacyIdentifier {
    mrdmOrganizationId: number;
    mrdmOrganizationUri: string;
    dhdLgzCode: number;
}

export class LogexLegacyIdentifier {
    code: number;
}

export interface CoinsLegacyIdentifier {
    coinsLegacyCode: string;
}

export class Address {
    id: number;
    countryCode: string;
    typeCode: string;
    region: string;
    province: string;
    city: string;
    postalCode: string;
    postBox: string;
    street: string;
    houseNumber: string;
    buildingExtension: string;
    houseNumberSuffix: string;
    latitude: number;
    longitude: number;
}

export enum PostalAddressType {
    Address,
    PostBox
}

export class Contact {
    id: number;
    typeCode: string;
    value: string;
}

export class NameId {
    id: number;
    name: string;
}

export enum CountryCode {
    Netherlands = "CountryCode.Netherlands",
    UnitedKingdom = "CountryCode.UnitedKingdom",
    Sweden = "CountryCode.Sweden",
    Europe = "CountryCode.Europe",
    Australia = "CountryCode.Australia",
    Finland = "CountryCode.Finland",
    France = "CountryCode.France",
    Germany = "CountryCode.Germany",
    SaudiArabia = "CountryCode.SaudiArabia",
    Norway = "CountryCode.Norway",
    CzechRepublic = "CountryCode.CzechRepublic",
    Belgium = "CountryCode.Belgium",
    Denmark = "CountryCode.Denmark",
    Estonia = "CountryCode.Estonia"
}
